import {
  SvgShareExternalLinkCustom,
  TextV2,
} from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { Box, Button, styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import useIsAboveMobile from 'components/hooks/useIsAboveMobile';
import InsightsLogo from 'components/Svgs/ASSET-InsightsLogoBlack.svg';

const StyledText = styled(TextV2)(({ theme }) => ({
  marginLeft: `${theme.spacing(spacingSizeMap.S)} !important`,
  paddingLeft: `${theme.spacing(spacingSizeMap.S)} !important`,
  borderLeft: `1px solid ${theme.palette.grey[500]}`,
}));

export const FAQsection = () => {
  const { t } = useTranslation();
  const aboveMobile = useIsAboveMobile('md');

  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[500]}`,
        marginTop: theme.spacing(spacingSizeMap.S),
        padding: theme.spacing(spacingSizeMap.S),
        borderRadius: '4px',
      })}
    >
      <Grid
        container
        sx={{
          flexDirection: aboveMobile ? 'row' : 'column-reverse',
          justifyContent: 'space-between',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Grid>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img
              alt={t('ui.io.profile.discovery.footer.logo_title')}
              src={InsightsLogo}
              width="111px"
              height="30px"
            />
            <StyledText>
              {t('ui.event-management.dashboard.faq-title')}
            </StyledText>
          </Box>
        </Grid>

        <Grid>
          <Button
            data-testid="access-support-button"
            variant="contained"
            startIcon={<SvgShareExternalLinkCustom stroke="#fff" />}
            sx={{ padding: '10px 20px 10px 20px', marginBottom: 'px' }}
            onClick={() =>
              window.open('https://support.insights.com/', '_blank')
            }
          >
            {t('ui.event-management.dashboard.button.access-support')}
          </Button>
        </Grid>
      </Grid>
      <Box
        sx={{
          width: '75%',
        }}
      >
        <TextV2>{t('ui.event-management.dashboard.faq-desc')}</TextV2>
      </Box>
    </Box>
  );
};
